import PropTypes from "prop-types";
import { Alert, Stack } from "@mui/material";
import ActionButton from "src/components/shared/ActionButton";
import { faqSuggestions, placeholderWarnings } from "./checks";

// The notes under an FAQ as it is typed: filler text, the house style
// (with "Use this" when the fix is a plain replacement: "does it take", not
// "does it takes"; hala-33) and a time or a price products set themselves.
// "Use this" only fills the field; nothing is saved.
export default function FaqNotes({ question, answer, onFix }) {
  const notes = [
    ...placeholderWarnings(question, answer).map((text, index) => ({ key: `filler-${index}`, text })),
    ...faqSuggestions(question, answer),
  ];
  if (!notes.length) return null;
  return (
    <Stack spacing={0.75} role="status" aria-live="polite">
      {notes.map((note) => (
        <Alert
          key={note.key}
          severity="warning"
          action={
            note.fix && onFix ? (
              <ActionButton variant="text" onClick={() => onFix(note.fix.field, note.fix.value)} aria-label={`Use this: “${note.fix.value}”`}>
                Use this
              </ActionButton>
            ) : null
          }
        >
          {note.text}
        </Alert>
      ))}
    </Stack>
  );
}

FaqNotes.propTypes = { question: PropTypes.string, answer: PropTypes.string, onFix: PropTypes.func };
